module.exports = __webpack_public_path__ + "static/media/money-packs-active-dark-icon.1f9a0569.svg";